import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

type AppRole = "admin" | "moderator" | "partner" | "user";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: AppRole;
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { user, loading, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground text-sm">Se încarcă…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/autentificare" replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <main className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center space-y-2">
          <h1 className="text-xl font-semibold">Acces interzis</h1>
          <p className="text-sm text-muted-foreground">Nu ai permisiunile necesare pentru această pagină.</p>
        </div>
      </main>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
